
/**
 * Created by wanglimin on 2017/4/27.
 */

var config = {
    defaultLang: 'en',
    allLangs: [
        "bn",
        "en",
        "en-US",
        "gu",
        "hi",
        "kn",
        "ml",
        "mr",
        "pa",
        "ta",
        "te",
        "ur",
        'od', 
        'bh', 
        'ra', 
        'ha', 
        'or', 
        'as'
    ]
}

export default config;



// WEBPACK FOOTER //
// ./src/assets/js/config-faq.js